import React from 'react';
import { Link } from 'react-router-dom';
import { Col, Container, Row } from 'react-bootstrap';

import AppLayout from '../../../layouts/AppLayout/AppLayout';
import { useLanguage } from '../../../context/LanguageProvider/LanguageProvider';
import { EXPERTISE_ITEMS, enrichExpertiseItem } from '../../../data/expertises';
import ExpertiseTechTags from '../../../components/ExpertiseTechTags/ExpertiseTechTags';

import { NioSection, NioCard } from '../../../components';
import PartnersLogos from '../../../components/PartnersLogos/PartnersLogos';

function CardImage({ webp, img, alt }) {
  const imgClass = 'jassp-feature-card-img rounded-3';
  if (!webp) {
    return (
      <div className="mb-4 d-flex justify-content-center">
        <img src={img} className={imgClass} alt={alt} loading="lazy" decoding="async" />
      </div>
    );
  }
  return (
    <div className="mb-4 d-flex justify-content-center">
      <picture>
        <source type="image/webp" srcSet={webp} />
        <img src={img} className={imgClass} alt={alt} loading="lazy" decoding="async" />
      </picture>
    </div>
  );
}

function DataDrivenHome() {
  const { t } = useLanguage();

  return (
    <AppLayout variant={13} titleKey="pages.dataDriven.title" rootClass="layout-12">
      <section className="nk-banner nk-banner-bs-driven is-theme is-theme-bg" data-bg-image="business-driven/banner-cover.webp">
        <div className="nk-banner-wrap">
          <Container>
            <Row className="justify-content-center">
              <Col lg={8}>
                <div className="nk-section-head text-center">
                  <h1 className="display-6 mb-lg-5">{t('dataDriven.banner.h1')}</h1>
                  <p className="fs-20 px-lg-7">{t('dataDriven.banner.lead')}</p>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </section>

      

      <NioSection className="nk-section-features py-7 py-lg-120 pt-lg-7 ">
        <div id="expertises" className="w-100 scroll-margin-top">
          <NioSection.Head alignX="center">
            <h2 className="text-center">{t('dataDriven.services.h2')}</h2>
            <p className="fs-20 mb-0 text-center px-lg-6">{t('dataDriven.services.lead')}</p>
            <p className="mt-3 mb-0">
              <Link to="/expertises" className="link-primary fw-semibold">
                {t('nav.expertises.viewAll')}
              </Link>
            </p>
          </NioSection.Head>
        </div>

        <NioSection.Content>
          <Row className="gy-5">
            {EXPERTISE_ITEMS.map((item) => (
              <Col key={item.slug} md={6} lg={4}>
                <NioCard className="text-center h-100">
                  <NioCard.Body className="p-lg-7 d-flex flex-column">
                    <CardImage webp={item.imageWebp} img={item.image} alt={t(item.altKey)} />
                    <div className="mb-4 flex-grow-1">
                      <h4 className="mb-2 text-capitalize">{t(item.titleKey)}</h4>
                      <p className="fs-16 line-clamp-3 mb-3">{t(item.homeBodyKey)}</p>
                      <ExpertiseTechTags
                        keywordKeys={enrichExpertiseItem(item).techKeywordsKeys}
                        className="justify-content-center"
                      />
                    </div>
                    <Link to={`/expertises/${item.slug}`} className="btn btn-sm btn-outline-primary">
                      {t('dataDriven.card.learnMore')}
                    </Link>
                  </NioCard.Body>
                </NioCard>
              </Col>
            ))}
          </Row>

          <div id="partners" className="jassp-partners mt-5 pt-5 pt-lg-7 border-top border-gray-200 scroll-margin-top">
            <PartnersLogos showHeading />
          </div>
        </NioSection.Content>
      </NioSection>
    </AppLayout>
  );
}

export default DataDrivenHome;
